<template>
  <nav :class="navigationClass">
    <h2 class="a11y-hidden">메뉴 네비게이션</h2>
    <ul>
      <li :class="activeClass('home')">
        <a href="#" @click.prevent="changeUrl({path: '/', name: 'home'})">
          <span class="nav-main-img">
            <home-icon-on v-if="currentMenu === 'home'"/>
            <home-icon v-else/>
          </span>
          <span class="nav-main-txt">홈</span>
        </a>
      </li>
      <li :class="activeClass('category')">
        <a href="#" @click.prevent="changeUrl({path: '/category', name: 'category'})">
          <span class="nav-main-img">
            <category-icon-on v-if="currentMenu === 'category'" />
            <category-icon v-else />
          </span>
          <span class="nav-main-txt">카테고리</span>
        </a>
      </li>
      <li :class="activeClass('search')">
        <a href="#" @click.prevent="changeUrl({path: '/search', name: 'search'})">
          <span class="nav-main-img">
            <search-icon-on v-if="currentMenu === 'search'" />
            <search-icon v-else/>
          </span>
          <span class="nav-main-txt">검색</span>
        </a>
      </li>
      <li :class="activeClass('my')">
        <a href="#" @click.prevent="changeUrl({path: '/my', name: 'my'})">
          <span class="nav-main-img">
            <img v-if="loginState" :src="'https://' + myProfileImage" :alt="imageAlt">
            <img v-else :src="myIconImage" :alt="myNotLoginIconAlt + ' 프로필 이미지'">
          </span>
          <span class="nav-main-txt">{{myText}}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import HomeIcon from '@/assets/svg/common/ico_home_normal.svg'
import HomeIconOn from '@/assets/svg/common/ico_home_selected.svg'
import CategoryIcon from '@/assets/svg/common/ico_category_normal.svg'
import CategoryIconOn from '@/assets/svg/common/ico_category_selected.svg'
import SearchIcon from '@/assets/svg/common/ico_search_normal.svg'
import SearchIconOn from '@/assets/svg/common/ico_search_selected.svg'
import { mapGetters } from 'vuex'
import { WavveOnProfileImageInfo } from '@/common/util/common'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { sendEventLogSearchOpen, sendEventLogExitToGnb } from '@/common/util/log.v2.send'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

export default {
  name: 'MainMenu',
  components: {
    HomeIcon,
    CategoryIcon,
    SearchIcon,
    HomeIconOn,
    CategoryIconOn,
    SearchIconOn
  },
  data () {
    return {
      myImage: 'ic-navi-my-logout',
      myImageAlt: 'wavve',
      isWavveOn: utils.cookies.isPooqZone(),
      wavveonType: utils.cookies.getPooqZoneType(),
      loginState: utils.cookies.getCredential() !== 'none',
      myProfileImage: utils.cookies.userInfo('profileimage'),
      imageAlt: utils.cookies.userInfo('alt'),
      navigationClass: 'nav-main'
    }
  },
  computed: {
    ...mapGetters([ 'currentMenu', 'isNavigationMenu' ]),
    myIconImage () {
      if (this.isWavveOn) {
        return require('../../assets/images/' + get(WavveOnProfileImageInfo(), 'image', ''))
      } else {
        return this.currentMenu === 'my' ? require('../../assets/images/ic-navi-my-logout-on.png') : require('../../assets/images/ico_profile_normal.png')
      }
    },
    myNotLoginIconAlt () {
      if (this.isWavveOn) {
        return get(WavveOnProfileImageInfo(), 'imageAlt', '')
      } else {
        return this.currentMenu === 'my' ? '웨이브 로그아웃 상태 및 마이 클릭' : '웨이브 로그아웃 상태 및 마이 미클릭'
      }
    },
    myText () {
      return this.loginState ? 'my' : '로그인/가입'
    }
  },
  methods: {
    changeUrl (gnbInfo) {
      const { path, name } = gnbInfo
      if (get(gnbInfo, 'name', '') === get(this.$route, 'name', '')) {
        document.documentElement.scrollTop = 0
      }

      if (LOG_SEND_LIST.includes(name)) {
        sendEventLogSearchOpen()
      } else {
        if (LOG_SEND_LIST.includes(this.$route.name)) sendEventLogExitToGnb({ name: name, route: this.$route, landingUrl: path })
      }
      this.$router.push(path)
    },
    activeClass (name) {
      return this.currentMenu === name ? 'nav-main-item nav-main-item-on' : 'nav-main-item'
    },
    mainNavigationClass () {
      this.navigationClass = this.isNavigationMenu ? 'nav-main' : 'nav-main nav-main-hidden'
    },
    init () {
      this.myProfileImage = utils.cookies.userInfo('profileimage')
      this.loginState = utils.cookies.getCredential() !== 'none'
      this.mainNavigationClass()
    }
  },
  created () {
    this.init()
  },
  watch: {
    isNavigationMenu () {
      this.mainNavigationClass()
    },
    $route () {
      this.init()
    }
  }
}
</script>
